import { useEffect, useState } from 'react';
import {
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
  TextField, InputAdornment, Chip, Dialog, DialogTitle, DialogContent, DialogActions, Button, IconButton
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';
import { FaWhatsapp } from 'react-icons/fa';
import Box from 'elements/Box';
import EmptyElement from 'elements/EmptyElement';
import { ApiRequest } from 'GlobalFunctions';

export default function WhatsappLogsList(props: any) {
  const { setLoading } = props;
  const [list, setList] = useState<any[]>([]);
  const [search, setSearch] = useState('');
  const [selectedRow, setSelectedRow] = useState<any>(null);

  useEffect(() => {
    setLoading(true);
    ApiRequest({
      url: '/whatsapp/logs',
      method: 'GET',
      setResponse: (res: any) => {
        setList(res.list || []);
        setLoading(false);
      },
    });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const filtered = list.filter(r => {
    const q = search.toLowerCase();
    return (
      (r.patient_name   || '').toLowerCase().includes(q) ||
      (r.nurse_name     || '').toLowerCase().includes(q) ||
      (r.patient_phone  || '').toLowerCase().includes(q) ||
      (r.patient_comuna || '').toLowerCase().includes(q)
    );
  });

  const thSx = {
    color: '#94a3b8', fontWeight: 700, fontSize: 11,
    textTransform: 'uppercase' as const,
    borderBottom: '1px solid #f1f5f9', py: 1.5,
  };

  return (
    <div className="content">
      <div className="ModuleWrapper">
        <div className="boxContainerHeader">
          <div className="boxContainerTitle">
            <h2 className="h2_title">Contactos WhatsApp</h2>
            <span className="h2_subtitle">{list.length} contactos registrados</span>
          </div>
        </div>

        <Box id="WhatsappLogsList" className="box100" style={{ padding: 0, overflow: 'hidden' }}>
          <div style={{ padding: '12px 16px 4px' }}>
            <TextField
              size="small"
              placeholder="Buscar por paciente, kinesiólogo, teléfono o comuna..."
              value={search}
              onChange={e => setSearch(e.target.value)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon sx={{ fontSize: 18, color: '#94a3b8' }} />
                  </InputAdornment>
                ),
              }}
              sx={{ width: 360, '& .MuiOutlinedInput-root': { borderRadius: 2, fontSize: 13 } }}
            />
          </div>

          <div style={{ padding: '8px 0 16px' }}>
            {filtered.length === 0 ? (
              <div style={{ padding: '40px 0' }}>
                <EmptyElement title="Sin contactos" subtitle="Aún no hay contactos WhatsApp registrados" />
              </div>
            ) : (
              <TableContainer>
                <Table size="small">
                  <TableHead>
                    <TableRow>
                      <TableCell sx={{ ...thSx, pl: 3 }}>Fecha</TableCell>
                      <TableCell sx={thSx}>Paciente</TableCell>
                      <TableCell sx={thSx}>Teléfono</TableCell>
                      <TableCell sx={thSx}>Comuna</TableCell>
                      <TableCell sx={thSx}>Kinesiólogo contactado</TableCell>
                      <TableCell sx={thSx}>Solicitud</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {filtered.map((row) => (
                      <TableRow
                        key={row.log_id}
                        hover
                        sx={{ '&:last-child td': { border: 0 }, '&:hover': { backgroundColor: '#f8fafc' } }}
                      >
                        <TableCell sx={{ pl: 3, py: 1.5, borderBottom: '1px solid #f1f5f9', fontSize: 13, color: '#475569', whiteSpace: 'nowrap' }}>
                          {row.created_at
                            ? new Date(row.created_at).toLocaleString('es-CL', { dateStyle: 'short', timeStyle: 'short' })
                            : '—'}
                        </TableCell>
                        <TableCell sx={{ py: 1.5, borderBottom: '1px solid #f1f5f9' }}>
                          <div style={{ fontWeight: 600, fontSize: 14, color: '#1e293b' }}>{row.patient_name || '—'}</div>
                          {row.patient_user_id && (
                            <div style={{ fontSize: 11, color: '#94a3b8' }}>Usuario registrado</div>
                          )}
                        </TableCell>
                        <TableCell sx={{ py: 1.5, borderBottom: '1px solid #f1f5f9' }}>
                          {row.patient_phone ? (
                            <a
                              href={`https://wa.me/+56${row.patient_phone}`}
                              target="_blank"
                              rel="noreferrer"
                              style={{ display: 'flex', alignItems: 'center', gap: 4, color: '#16a34a', fontWeight: 600, fontSize: 13, textDecoration: 'none' }}
                            >
                              <FaWhatsapp size={14} /> {row.patient_phone}
                            </a>
                          ) : '—'}
                        </TableCell>
                        <TableCell sx={{ py: 1.5, borderBottom: '1px solid #f1f5f9', fontSize: 13, color: '#475569' }}>
                          {row.patient_comuna || '—'}
                        </TableCell>
                        <TableCell sx={{ py: 1.5, borderBottom: '1px solid #f1f5f9' }}>
                          <Chip
                            label={row.nurse_name}
                            size="small"
                            sx={{ background: '#dbeafe', color: '#1d4ed8', fontWeight: 600, fontSize: 11 }}
                          />
                        </TableCell>
                        <TableCell
                          onClick={() => setSelectedRow(row)}
                          sx={{ py: 1.5, borderBottom: '1px solid #f1f5f9', fontSize: 13, color: '#475569', maxWidth: 260, cursor: 'pointer', '&:hover': { color: '#1d4ed8' } }}
                        >
                          <div style={{ overflow: 'hidden', display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical' as any }}>
                            {row.message || '—'}
                          </div>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            )}
          </div>
        </Box>
      </div>

      <Dialog open={!!selectedRow} onClose={() => setSelectedRow(null)} maxWidth="sm" fullWidth>
        <DialogTitle sx={{ pr: 6, fontWeight: 700 }}>
          Solicitud completa
          <IconButton onClick={() => setSelectedRow(null)} sx={{ position: 'absolute', right: 8, top: 8 }}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          {selectedRow && (
            <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
              <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', fontSize: 13, color: '#64748b' }}>
                <span><strong>Paciente:</strong> {selectedRow.patient_name || '—'}</span>
                <span>·</span>
                <span><strong>Comuna:</strong> {selectedRow.patient_comuna || '—'}</span>
                <span>·</span>
                <span><strong>Kinesiólogo:</strong> {selectedRow.nurse_name || '—'}</span>
              </div>
              <div style={{ fontSize: 15, color: '#1e293b', lineHeight: 1.7, whiteSpace: 'pre-wrap' }}>
                {selectedRow.message || '—'}
              </div>
            </div>
          )}
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2, gap: 1 }}>
          {selectedRow?.nurse_email && (
            <Button
              variant="outlined"
              size="small"
              onClick={() => {
                const to      = encodeURIComponent(selectedRow.nurse_email);
                const subject = encodeURIComponent(`Solicitud de paciente: ${selectedRow.patient_name || ''}`);
                const body    = encodeURIComponent(selectedRow.message || '');
                window.open(`https://mail.google.com/mail/?view=cm&to=${to}&su=${subject}&body=${body}`, '_blank');
              }}
              startIcon={<span style={{ fontSize: 16 }}>✉️</span>}
            >
              Enviar correo a {selectedRow.nurse_name}
            </Button>
          )}
          <Button onClick={() => setSelectedRow(null)} variant="contained" size="small">Cerrar</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
